module.exports = __webpack_public_path__ + "static/img/img2.55d0255.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qmyd/qgz/img2.jpg
// module id = gris
// module chunks = 36